<script>
  export let title
</script>

<style>
  :global(.OdTT4) {
    display: flex;
    align-items: center;
    margin: 0 0 20px 0;
    font-size: 18px;
  }
</style>

<div class="OdTT4">
  <slot />
  <div class="">{title}</div>
</div>
